import * as yup from "yup";

// Login form
export const loginSchema = yup.object().shape({
  username: yup
    .string()
    .email("Enter a valid email")
    .required("Please enter username"),
  password: yup
    .string()
    .required("Please enter password"),
});

// Customer form
export const customerSchema = yup.object().shape({
  customerName: yup
    .string()
    .max(255, "Max length is 255 characters")
    .required("Customer name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  address: yup.string().required("Address is required"),
  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  pincode: yup
    .string()
    .matches(/^[0-9]{6}$/, "Pincode must be 6 digits")
    .required("Pincode is required"),
});

export const basicInfoSchema = yup.object().shape({
  providerName: yup
    .string()
    .max(255, "Max length is 255 characters")
    .required("Provider name is required"),
  contactPerson: yup
    .string()
    .max(255, "Max length is 255 characters")
    .required("Contact person is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  phoneNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  categoriesOffered: yup
    .array()
    .min(1, "Select at least one category")
    .required("Categories are required"),
  aboutCompany: yup.string(),
});
export const servicesSchema = yup.object().shape({
  services: yup.array().of(
    yup.object().shape({
      service: yup.string().required("Service is required"),
      cost: yup
        .number()
        .typeError("Cost must be a number")
        .positive("Cost must be greater than 0")
        .required("Cost is required"),
    })
  ),
});
export const serviceAddonSchema = yup.object().shape({
  name: yup
    .string()
    .max(255, "Name must not exceed 255 characters")
    .required("Name is required"),
  type: yup
    .string()
    .oneOf(["Services", "Addons"], "Select a valid type")
    .required("Type is required"),
});

export const couponSchema = yup.object().shape({
  code: yup
    .string()
    .max(255, "Coupon code must not exceed 255 characters")
    .required("Coupon code is required"),
  title: yup
    .string()
    .max(255, "Title must not exceed 255 characters")
    .required("Title is required"),
  description: yup
    .string()
    .max(1000, "Description must not exceed 1000 characters"),
  discountType: yup
    .string()
    .oneOf(["Percentage", "Flat"], "Select a valid discount type")
    .required("Discount type is required"),
  discountValue: yup
    .number()
    .typeError("Discount value must be a number")
    .positive("Discount value must be greater than 0")
    .required("Discount value is required"),
  minOrderAmount: yup
    .number()
    .typeError("Minimum order amount must be a number")
    .positive("Minimum order amount must be greater than 0"),
  maxDiscountAmount: yup
    .number()
    .typeError("Maximum discount amount must be a number")
    .positive("Maximum discount amount must be greater than 0"),
  usageLimit: yup
    .number()
    .typeError("Usage limit must be a number")
    .integer("Usage limit must be an integer")
    .positive("Usage limit must be greater than 0"),
  validFrom: yup
    .date()
    .typeError("Enter a valid start date")
    .required("Valid from date is required"),
  validTo: yup
    .date()
    .typeError("Enter a valid end date")
    .min(
      yup.ref("validFrom"),
      "Valid to date cannot be before valid from date"
    )
    .required("Valid to date is required"),
  category: yup.string().required("Select a category"),
  subcategory: yup.string().required("Select a subcategory"),
  service: yup.string().required("Select a Service"),
});